var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "recycle-body" }, [
    _vm.recycleData.list.length > 0
      ? _c(
          "div",
          { ref: "scrollContainer", staticClass: "recycle-content" },
          _vm._l(_vm.recycleData.list, function(fileItem, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "file-item-body",
                class: { "file-item-selected": fileItem.selected },
                on: {
                  click: function($event) {
                    return _vm.clickSelectedItem(fileItem)
                  }
                }
              },
              [
                fileItem.data_type != 3
                  ? _c("div", { staticClass: "item-selected" }, [
                      !fileItem.selected
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/ic_selected_n.png"),
                              alt: ""
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/assets/ic_selected_y.png"),
                              alt: ""
                            }
                          })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "item-body" }, [
                  _c("div", { staticClass: "file-icon" }, [
                    (fileItem.file_type == 1 || fileItem.file_type == 2) &&
                    fileItem.thumb != "" && fileItem.thumb != null
                      ? _c("img", {
                          attrs: { src: fileItem.thumb, alt: "Icon" }
                        })
                      : _c("img", {
                          attrs: {
                            src: _vm.fileIcon[fileItem.file_type],
                            alt: "Icon"
                          }
                        })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "file-content" }, [
                    _c("div", { staticClass: "file-name" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(fileItem.name) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "file-time" }, [
                      _vm._v(
                        "\n            " + _vm._s(fileItem.createtime) + " "
                      ),
                      fileItem.data_type != 3
                        ? _c("label", [_vm._v(_vm._s(fileItem.size))])
                        : _vm._e()
                    ])
                  ])
                ])
              ]
            )
          }),
          0
        )
      : _c("div", { ref: "scrollContainer" }, [_c("empty")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670f5ee8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670f5ee8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/tab_recycle.vue
// module id = null
// module chunks = 